<template>
  <div
    id="print-area"
    ref="printArea"
    style="display: none; display: flex; justify-content: space-between;"
  >
    <div class="nota">
      <div style="font-family: monospace; font-size: 10px; width: 100%; margin: 0; margin-bottom: 10px;">
        <div style="text-align: center;">
          <div
            style="margin: 0;"
            class="logo-wrapper"
          >
            <logo />
          </div>
          <p style="margin: 0;">
            {{ data.toko.address }}
          </p>
          <p style="margin: 0;">
            {{ data.toko.phone }}
          </p>
        </div>

        <div style="font-family: monospace; font-size: 10px; width: 100%; margin: 0; margin-top: 4px; margin-bottom: 3px;">
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Nomor:</span>
            <span> &nbsp;{{ data.trx_no }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Status:</span>
            <span> &nbsp;{{ data.paid_status }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Tanggal Nota: </span>
            <span>&nbsp;{{ new Date().toISOString().slice(0, 10) }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Tanggal Transaksi: </span>
            <span>&nbsp;{{ data.trx_date }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Telp: </span>
            <span>&nbsp;{{ data.customer.raw.phone }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Kasir: </span>
            <span>&nbsp;{{ data.salesPerson }}</span>
          </div>
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
        </div>

        <div
          v-for="item in data.items"
          :key="item.id"
          style="margin-bottom: 6px;"
        >
          <div style="margin-bottom: 2px;">
            <div style="width: 100%;">
              <b>{{ item.itemTitle.product }}</b> {{ (!item.is_stock)?`(${item.p} X ${item.l})`:'' }}
            </div>
            <div style="display: flex; flex-wrap: wrap; font-size: 10px;">
              <div style="width: 10%;">
                {{ parseInt(item.qty) }}
              </div>
              <div style="width: 90%;">
                {{ item.unit }} @ Rp{{ new Intl.NumberFormat('id-ID').format(item.price) }}
              </div>
              <div style="width: 30%;">
                disc: Rp{{ new Intl.NumberFormat('id-ID').format(item.discount) }}
              </div>
              <div style="width: 70%; text-align: right;">
                Rp{{ new Intl.NumberFormat('id-ID').format(item.subtotal) }}
              </div>
            </div>
          </div>
        </div>

        <div style="width: 100%;">
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
          Ket : {{ data.description }}
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
        </div>

        <div style="display: flex; flex-direction: column; align-items: flex-end; margin-bottom: 5px;">
          <table>
            <tr>
              <td>SubTotal</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.total) }}</td>
            </tr>
            <tr>
              <td>Diskon</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.disc_exp) }}</td>
            </tr>
            <tr>
              <td>Total</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.grand_total) }}</td>
            </tr>
            <tr>
              <td>Bayar</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.total_paid) }}</td>
            </tr>
            <tr>
              <td>Kurang Bayar</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.grand_total - data.total_paid) }}</td>
            </tr>
          </table>
          <hr style="border: none; border-top: 1px dashed #000; margin: 8px 0;">

          <div style="text-align: center; margin-top: 10px;">
            <div style="margin-bottom: 25px;">
              <div>TTD Pelanggan</div>
              <div style="margin-top: 30px;">
                (.........................)
              </div>
            </div>

            <div style="margin-top: 15px;">
              <div>TTD Penjual</div>
              <div style="margin-top: 30px;">
                (.........................)
              </div>
            </div>
          </div>
        </div>

        <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">

        <p style="text-align: center; margin-top: 10px;">
          {{ data.toko.footer_note }}
        </p>
        <p style="text-align: center; margin: 0;">
          <vue-barcode
            :value="codeBar"
            format="CODE128"
            :width="2"
            :height="50"
            :font-size="10"
          />
        </p>
      </div>

    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import VueBarcode from 'vue-barcode'
import Logo from '@core/layouts/components/Logo.vue'

export default {
  components: {
    VueBarcode,
    Logo,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      codeBar: this.data.trx_no,
    }
  },
  methods: {
    formatRupiah(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).format(value)
    },
    print() {
      const printContents = this.$refs.printArea.innerHTML
      const w = window.open('', '', '')
      w.document.write(`
      <html>
        <head>
          <style>
            @media print {
              @page {
                size: 58mm auto;
                margin: 0;
              }
              body {
                font-family: monospace;
                font-size: 10px;
                margin: 0;
                padding: 5px;
              }
              .center { text-align: center; }
              tr {font-size: 10px; }
              hr { border: dashed 1px black; }
              .logo-wrapper img {
                max-width: 100%;
                height: auto;
                display: inline-block;
                max-width: 200px;
                margin-bottom: 40px;
                margin-top: 20px;
              }
            }
          </style>
        </head>
        <body onload="window.print();window.close(); ">
          ${printContents}
        </body>
      </html>
    `)
      w.document.close()
    },

  },
}
</script>
